var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from "events";
import { debugLogger, errorLogger } from '../../debug';
import Platform from "../common/plat";
/**
 * @file 腾讯视频下载器
 */
export var DOWNLOADER = {
    // 等待下载
    PENDING: "pending",
    // 开始下载
    DOWNLOAD: "download",
    // 下载中
    DOWNLOADING: "downloading",
    // 暂停
    PAUSE: "pause",
    // 恢复下载
    RESUME: "resume",
    CANCEL: "cancel",
    // 下载完成
    COMPLETE: "complete",
    //发生点击下载后的下载完成（真实下载完成）
    REAL_COMPLETE: "real_complete",
    // 开始安装
    INSTALL: "install",
    // 已安装
    INSTALLED: "installed",
    // 出现错误
    ERROR: "error",
    // 未知
    UNKNOWN: "unknown",
    // 安装后被卸载
    UNINSTALLED: "uninstalled",
};
var TV_DOWNLOAD_STATUS = {
    "10": DOWNLOADER.INSTALLED,
    "11": DOWNLOADER.INSTALL,
    "12": DOWNLOADER.DOWNLOAD,
    "13": DOWNLOADER.DOWNLOADING,
    "14": DOWNLOADER.PAUSE,
    "16": DOWNLOADER.PENDING,
};
/**
 * TV下载器实现 https://dev.film.qq.com/weixin/test.html
 * 暂时改用TBS下载拦截 相关文档：http://tbs.wsd.com
 */
var TVDownloader = /** @class */ (function (_super) {
    __extends(TVDownloader, _super);
    function TVDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'TVDownloader';
        _this.status = 0;
        _this.progress = 0;
        _this.opt = __assign({}, opt);
        return _this;
    }
    TVDownloader.prototype.ready = function () {
        return new Promise(function (resolve) {
            if (window.TenvideoJSBridge) {
                resolve(window.TenvideoJSBridge);
            }
            else {
                // 这里可以酌情考虑是否要加超时
                document.addEventListener('onTenvideoJSBridgeReady', function () {
                    resolve(window.TenvideoJSBridge);
                }, false);
            }
        });
    };
    TVDownloader.prototype.start = function () {
        var _this = this;
        var _a = this.opt, url = _a.url, appkey = _a.appkey, // 需要新加的参数
        packagename = _a.packagename, filename = _a.filename, fileIcon = _a.fileIcon, appStore = _a.appStore;
        var commonParams = {
            packageUrl: "".concat(appkey, "://"),
            packageName: packagename,
            iconUrl: fileIcon,
            appName: filename,
        };
        var params;
        if (Platform.isIos) {
            params = __assign(__assign({}, commonParams), { itunesUrl: appStore });
        }
        else {
            params = __assign(__assign({}, commonParams), { downloadUrl: url });
        }
        this.invoke('download3rdApp', params, function (res) {
            debugLogger('下载接口回调', JSON.stringify(res));
        });
        if (Platform.isAndroid) {
            this.eventOn('onDownloadTaskProgressChanged', function (ret) {
                debugLogger('下载进度变化', ret, typeof ret);
                try {
                    var progress = _this.parseResult(ret).progress;
                    _this.progress = progress;
                }
                catch (e) {
                    errorLogger('下载进度异常', e);
                }
            });
            this.eventOn('onDownloadTaskStateChanged', function (ret) {
                debugLogger('下载状态变化', ret, typeof ret);
                try {
                    var retInfo = _this.parseResult(ret);
                    if (Object.keys(TV_DOWNLOAD_STATUS).indexOf("".concat(retInfo === null || retInfo === void 0 ? void 0 : retInfo.state)) > -1) {
                        _this.status = retInfo.state;
                    }
                }
                catch (e) {
                    errorLogger('下载状态异常', e);
                }
            });
        }
    };
    TVDownloader.prototype.pause = function () {
        var _this = this;
        var _a = this.opt, url = _a.url, packagename = _a.packagename;
        if (Platform.isIos) {
            errorLogger('异常:', 'pauseDowload3rdApp', 'ios无此方法');
        }
        else {
            this.invoke('pauseDowload3rdApp', {
                downloadUrl: url,
                packageName: packagename,
            }, function (res) {
                console.info('暂停下载接口pauseDowload3rdApp回调', _this.parseResult(res));
            });
        }
    };
    TVDownloader.prototype.resume = function () {
        this.start();
    };
    TVDownloader.prototype.install = function () {
        this.start();
    };
    TVDownloader.prototype.open = function () {
        // 腾讯视频允许location跳转到app
        var active = this.opt.active;
        return location.href = active;
    };
    TVDownloader.prototype.isInstalled = function () {
        var _this = this;
        var params = {};
        var _a = this.opt, packagename = _a.packagename, appkey = _a.appkey;
        if (Platform.isIos) {
            params = {
                pkgName: appkey,
                pkgUrl: "".concat(appkey, "://"),
            };
        }
        else {
            params = {
                pkgName: packagename,
            };
        }
        return new Promise(function (resolve) {
            _this.invoke('isInstalled', params, function (res) {
                var _a;
                var data = _this.parseResult(res);
                console.info('isInstalled回调', data);
                resolve((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.installed);
            });
        });
    };
    TVDownloader.prototype.getStatus = function () {
        return TV_DOWNLOAD_STATUS[this.status];
    };
    TVDownloader.prototype.getProgress = function () {
        return parseInt(String(this.progress), 10);
    };
    TVDownloader.prototype.parseResult = function (res) {
        try {
            return typeof res === 'string' ? JSON.parse(res) : res;
        }
        catch (e) {
            errorLogger('api返回值解析错误', e, res);
            return null;
        }
    };
    TVDownloader.prototype.invoke = function (apiName, params, callback) {
        if (window.TenvideoJSBridge) {
            window.TenvideoJSBridge.invoke(apiName, params, callback);
        }
        else {
            errorLogger('sdk初始化异常', apiName, '');
        }
    };
    TVDownloader.prototype.eventOn = function (eventName, callback) {
        if (window.TenvideoJSBridge) {
            window.TenvideoJSBridge.on(eventName, callback);
        }
        else {
            errorLogger('sdk初始化异常', eventName, '');
        }
    };
    return TVDownloader;
}(EventEmitter));
export default TVDownloader;
// 腾讯视频的jsapi下载状态和下载进度的获取是分开的
// export default class TVDownLoader extends EventEmitter {
//     constructor({ options = {}, instance }) {
//         super();
//     }
//     __bindEvent() {
//         const self = this;
//         window.TenvideoJSBridge.invoke('register3rdAppDownloadListener', null, () => {
//             window.TenvideoJSBridge.on("onDownloadTaskStateChanged", (ret) => {
//                 //参数为{"packageName":"", "state":0, "errorCode":0, "errorMessage":""}
//                 console.log(ret);
//             });
//             window.TenvideoJSBridge.on("onDownloadTaskProgressChanged", function (ret) {
//                 //参数为{"packageName": "", "progress":60}
//                 console.log('onDownloadTaskProgressChanged', ret);
//             });
//         });
//     }
//     restore() {
//         const downloadUrl = null;
//         const packageName = null;
//         const self = this;
//         return new Promise((resolve, reject) => {
//             window.TenvideoJSBridge.invoke(
//                 'checkDowload3rdAppState',
//                 {
//                     "downloadUrl": downloadUrl,
//                     "packageName": packageName
//                 },
//                 (ret) => {
//                     try {
//                         ret = JSON.parse(ret);
//                         console.log('tv restore', ret.result);
//                         if (ret.errCode - 0 === 0 && ret.result) {
//                             const { uiState, progress } = ret.result;
//                             self.__bindEvent();
//                             resolve({
//                                 status: TV_DOWNLOAD_STATUS[uiState + ''],
//                                 data: { progress }
//                             });
//                         } else {
//                             console.error('获取下载状态出错:tv');
//                         }
//                     } catch (e) {
//                         console.error('获取下载状态出错:tv');
//                     }
//                 }
//             );
//         });
//     }
//     download() {
//         this.downloadAndInstall();
//     }
//     install() {
//         this.downloadAndInstall();
//     }
//     pause() {
//         const app = {};
//         console.log('qb downlader pause');
//         window.TenvideoJSBridge.invoke(
//             'pauseDowload3rdApp',
//             { ...app },
//             function (ret) { });
//     }
//     resume() {
//         console.log('qb downlader resume');
//         this.downloadAndInstall();
//     }
//     __waitAppInstall() {
//         const app: any = {};
//         return new Promise((resolve, reject) => {
//             const __waitAppInstallTimer = window.setInterval(() => {
//                 window.TenvideoJSBridge.checkAppInstall({
//                     packageName: app.packageName,
//                     packageUrl: app.packageUrl
//                 }).then(res => {
//                     if (res.installed) {
//                         this.emit(DOWNLOADER.INSTALLED);
//                         resolve();
//                         window.clearInterval(__waitAppInstallTimer);
//                     }
//                 }).catch(err => {
//                     console.error('tv waitAppInstall failed');
//                 });
//             }, 1000);
//         });
//     }
//     downloadAndInstall() {
//         if (Platform.isIos) {
//             window.location.href = '';
//         } else {
//             const downloadInfo = {};
//             window.TenvideoJSBridge.invoke(
//                 'download3rdApp',
//                 { ...downloadInfo },
//                 function (ret) {
//                     console.log(ret);
//                 }
//             );
//         }
//     }
// }
// function checkAppInstall(options) {
//     if (Platform.isIos) {
//         return Promise.resolve({
//             installed: false
//         });
//     }
//     return new Promise((resolve, reject) => {
//         // 返回结果: {"errCode":0, "errMsg":"", "result":{"installed":true}}
//         window.TenvideoJSBridge.invoke(
//             'isInstalled',
//             { "pkgName": options.packageName },
//             (ret) => {
//                 let installed = false;
//                 try {
//                     ret = JSON.parse(ret);
//                     installed = Number(ret.errCode) === 0 && ret.result && ret.result.installed
//                 } catch (e) {
//                     console.error('tv checked installed error', e);
//                 } finally {
//                     resolve({ installed })
//                 }
//             });
//     });
// }
